import * as $ from 'jquery';

import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CustomMessages, EasyDialog } from '@shared';
import { FileDragDropComponent } from '@shared/components/file-drag/file-drag-drop.component';
import { SidebarComponent } from 'app/theme/admin-layout/sidebar/sidebar.component';
import { SupportingDocumentBean } from 'app/model/supporting-document-bean';
import { SupportingDocumentDTO } from 'app/model/supporting-document-dto';
import { SupportingDocumentService } from 'app/service/supporting-doc-service';
import { environment } from '@env/environment';
import { TranslatePipe } from '@shared/pipes/translate.pipe';
import { UrlConfigService } from 'app/service/url-config.service';
import { CommonDTO } from 'app/model/common-dto';
import { CommonService } from 'app/service/common.service';
import { UmbrellaGroupDTO } from 'app/model/umbrella-group-dto';

@Component({
  selector: 'app-attachmentlist',
  templateUrl: './attachmentlist.component.html',
  styleUrls: ['./attachmentlist.component.scss', '../../../../theme/loader/loader.component.scss'],
  providers: [TranslatePipe],
})
export class AttachmentlistComponent implements OnInit {
  maxUploadSizeInMb: number = environment.MAX_UPLOAD_SIZE_IN_MB;
  fileExtnNotAllowedToUpload: string = environment.FILE_EXTN_NOT_ALLOWED_TO_UPLOAD;
  supportingDocumentDto: SupportingDocumentDTO = new SupportingDocumentDTO();
  supportingDocumentList: SupportingDocumentBean[] = [];
  supportingDocumentValue: SupportingDocumentBean = new SupportingDocumentBean();
  fileArray: File[] = [];
  files: File[] = [];
  deleteItem: SupportingDocumentBean;
  showSelectedItemComments: string;
  @Input() enableAllTransaction: boolean;
  @Input() auditItemDetails: SupportingDocumentDTO;
  @ViewChild('showErrorMessage', { static: true }) showErrorMessageId: ElementRef;
  @ViewChild(FileDragDropComponent, { static: false })
  private fileDragDrop: FileDragDropComponent;
  TOKEN = 'token';
  token: String;
  parsedJson: any;
  errorMsgId: number;
  comments: string;
  userTeamType: string;
  USER_TEAM_TYPE = 'userTeamType';
  shouldDoIt: boolean = true;
  suppDto: SupportingDocumentDTO = new SupportingDocumentDTO();
  supportingDocumentDetails: SupportingDocumentDTO = new SupportingDocumentDTO();
  totalSuppDocs: number = 0;
  totalAuditeeDocs: number = 0;
  uploadStart: boolean = false;
  commonDTO: CommonDTO = new CommonDTO();
  parsedJSON: any;
  auditAreaId: string;
  @Output() closePanelattachments: EventEmitter<boolean> = new EventEmitter();
  @Output() suppDocCountEmitEvt: EventEmitter<Number> = new EventEmitter();

  //isDocumentRepositoryCall value true for hide table is Supporting document window open from document repository page.
  @Input() isDocumentRepositoryCall: boolean;
  @Input() isAuditorOrAuditee: string;
  supportingDocStatus: any;
  pdcaCount: any;
  constructor(
    private suppDocService: SupportingDocumentService,
    public dialog: EasyDialog,
    private ts: TranslatePipe,
    private sidebarComponent: SidebarComponent,
    private customMessage: CustomMessages,
    private urlConfigService: UrlConfigService, private commonService: CommonService,
  ) { }

  ngOnInit() {
    // in case dept id, comp id are missing
    if (this.auditItemDetails.departmentId === undefined) {
      this.suppDto.auditScopeId = this.auditItemDetails.auditScopeId;
      //Getting department List. Incorrect method name.
      this.suppDocService.getSupportingDocumentDetails(this.suppDto).subscribe(
        (data: any) => {
          this.parsedJson = JSON.parse(JSON.stringify(data));
          this.supportingDocumentDetails = this.parsedJson;
          this.supportingDocumentDto.auditScopeId = this.auditItemDetails.auditScopeId;
          this.supportingDocumentDto.validationForAttachement = this.auditItemDetails.validationForAttachement;
          this.supportingDocumentDto.companyId = this.supportingDocumentDetails.companyId;
          this;
          this.supportingDocumentDto.buId = this.supportingDocumentDetails.buId;
          this.supportingDocumentDto.isFinalReportReleased = this.supportingDocumentDetails.isFinalReportReleased;
          this.supportingDocumentDto.isScopeItemNC = this.supportingDocumentDetails.isScopeItemNC;
          this.supportingDocumentDto.auditProgramId = this.supportingDocumentDetails.auditProgramId;
          this.supportingDocumentDto.departmentId = this.supportingDocumentDetails.departmentId;
          this.supportingDocumentDto.deptName = this.supportingDocumentDetails.deptName;
          this.supportingDocumentDto.sectionName = this.supportingDocumentDetails.sectionName;
          this.supportingDocumentDto.businessProcessDescription = this.supportingDocumentDetails.businessProcessDescription;
          this.supportingDocumentDto.sectionCode = this.supportingDocumentDetails.sectionCode;
          this.supportingDocumentDto.attachementCount = this.supportingDocumentDetails.attachementCount;
          this.pdcaCount = this.auditItemDetails.pdcaStatus;
          this.userTeamType = localStorage.getItem(this.USER_TEAM_TYPE);
          this.getSupportingDocList('onLoad');
        },
        error => {
          this.sidebarComponent.showHideLoader(false);
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      );
    } else {
      this.supportingDocumentDto.auditScopeId = this.auditItemDetails.auditScopeId;
      this.supportingDocumentDto.companyId = this.auditItemDetails.companyId;
      this.supportingDocumentDto.buId = this.auditItemDetails.buId;
      this.supportingDocumentDto.isFinalReportReleased = this.auditItemDetails.isFinalReportReleased;
      this.supportingDocumentDto.isScopeItemNC = this.auditItemDetails.isScopeItemNC;
      this.supportingDocumentDto.auditProgramId = this.auditItemDetails.auditProgramId;
      this.supportingDocumentDto.departmentId = this.auditItemDetails.departmentId;
      this.supportingDocumentDto.deptName = this.auditItemDetails.deptName;
      this.supportingDocumentDto.sectionName = this.auditItemDetails.sectionName;
      this.supportingDocumentDto.businessProcessDescription = this.auditItemDetails.businessProcessDescription;
      this.supportingDocumentDto.sectionCode = this.auditItemDetails.sectionCode;
      this.supportingDocumentDto.validationForAttachement = this.auditItemDetails.validationForAttachement;
      this.supportingDocumentDto.attachementCount = this.auditItemDetails.attachementCount;
      this.userTeamType = localStorage.getItem(this.USER_TEAM_TYPE);
      this.pdcaCount = this.auditItemDetails.pdcaStatus;
      this.getSupportingDocList('onLoad');
    }

    this.getSiteAndAuditAreaIdByAuditId()
  }
  siteId: any
  getSiteAndAuditAreaIdByAuditId() {

    this.commonDTO.auditId = this.auditItemDetails.auditProgramId;
    this.commonService.getSiteAndAuditAreaIdByAuditId(this.commonDTO).subscribe(data => {
      this.parsedJSON = JSON.parse(JSON.stringify(data));
      this.auditAreaId = this.parsedJSON[0].auditAreaId;
      this.siteId = this.parsedJSON[0].siteId;
      this.getUmbrellaGroupByClientIdSiteId();
    }),
      error => {
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      };
  }
  umbrellaGroupList: UmbrellaGroupDTO[] = [];
  allowAttachementForFifty: boolean = false;
  getUmbrellaGroupByClientIdSiteId() {
    this.commonDTO.auditAreaId = this.auditAreaId;
    this.commonDTO.siteId = this.siteId;
    this.commonService.getUmbrellaGroupByClientIdSiteId(this.commonDTO).subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.umbrellaGroupList = this.parsedJson;

        this.umbrellaGroupList.forEach(data => {

          if (data.groupId == '23' && data.umbrellaGroupSettingValue == '1') {
            this.allowAttachementForFifty = true;
          }

        });
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }
  closed() {
    if (this.fileDragDrop != undefined && this.fileDragDrop.selectedFiles.length > 0) {
      let obj = this;
      obj.dialog.confirm(
        obj.ts.transform('cams.label.common.confirm'),
        obj.ts.transform('cams.label.common.confirmationToUploadFile'),
        async function () {
          obj.saveSuppDocument();
        },
        function () {
          obj.closePanelattachments.emit(false);
          obj.fileDragDrop.selectedFiles = [];
          obj.fileDragDrop.files = [];
        }
      );
    } else {
      this.closePanelattachments.emit(false);
      this.fileDragDrop.selectedFiles = [];
      this.fileDragDrop.files = [];
    }
  }

  getSupportingDocList(actionType) {
    if (actionType == 'onLoad') {
      this.sidebarComponent.showHideLoader(true);
    }
    this.suppDocService.getSupportingDocumentList(this.supportingDocumentDto).subscribe(
      (data: any) => {
        this.supportingDocumentList = data;
        if (this.supportingDocumentList.length == 0) {
          this.supportingDocumentList = [];
          this.sidebarComponent.showHideLoader(false);
        }
        if (this.supportingDocumentList.length > 0) {
          this.shouldDoIt = true;
          this.supportingDocumentList.map(esdl => {
            esdl.showComments = false;
          });
        }
        // this.sidebarComponent.showHideLoader(false);
        this.totalSuppDocs = 0;

        this.supportingDocumentList.forEach(element => {
          this.totalSuppDocs++;
          if (element.privilegeArea == 'Auditee Area') {
            this.totalAuditeeDocs++;
          }
        });
        this.suppDocCountEmitEvt.emit(this.totalAuditeeDocs);
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }

  showCommentsInput(actionType, item: SupportingDocumentBean) {
    if (actionType === 'Open') {
      this.supportingDocumentList.map(esdl => {
        if (item.documentId === esdl.documentId) {
          esdl.showComments = true;
        }
      });
    } else {
      this.supportingDocumentList.map(esdl => {
        if (item.documentId === esdl.documentId) {
          esdl.showComments = false;
        }
      });
    }
  }

  saveSupportingDocComments(item: SupportingDocumentBean) {
    this.supportingDocumentDto.documentId = item.documentId;
    this.supportingDocumentDto.comments = this.comments;
    this.supportingDocumentDto.isFinalReportReleased = this.auditItemDetails.isFinalReportReleased;
    this.supportingDocumentDto.isScopeItemNC = this.auditItemDetails.isScopeItemNC;
    this.sidebarComponent.showHideLoader(true);
    this.suppDocService.saveComments(this.supportingDocumentDto).subscribe(
      (data: any) => {
        if (data.status == 1) {
          this.customMessage.showSuccessMessage('cams.label.common.operationCompletedSuccessfully');
          this.comments = '';
          this.getSupportingDocList('List');
        }
        this.fileDragDrop.files = [];
        this.fileDragDrop.selectedFiles = [];
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }

  deleteSupportingDoc() {
    this.supportingDocumentValue = this.deleteItem;
    this.supportingDocumentValue.companyId = this.auditItemDetails.companyId;
    this.supportingDocumentValue.buId = this.auditItemDetails.buId;
    this.supportingDocumentValue.auditScopeId = this.auditItemDetails.auditScopeId;
    this.supportingDocumentDto.documentId = this.deleteItem.documentId;
    this.supportingDocumentValue.totalSize = this.supportingDocumentList.length;

    if (parseInt(this.auditItemDetails.isFinalReportReleased) == 1) {
      this.customMessage.showErrorMessage(
        'cams.label.attachmentList.cannotDeleteAlreadyReleasedFinalReport',
        ''
      );
      return false;
    }
    if (this.deleteItem.privilegeArea != this.userTeamType) {
      if (this.deleteItem.privilegeArea == 'Auditor Area' && this.userTeamType == 'Auditee Area') {
        this.customMessage.showErrorMessage(
          'cams.label.attachmentList.auditeeTeamCannotDeleteÄuditorTeamDocument',
          ''
        );
        return false;
      }
      if (this.deleteItem.privilegeArea == 'Auditee Area' && this.userTeamType == 'Auditor Area') {
        this.customMessage.showErrorMessage(
          'cams.label.attachmentList.auditorTeamCannotDeleteAuditeeTeamDocument',
          ''
        );
        return false;
      }
      if (
        (this.supportingDocumentDto.validationForAttachement = true && this.totalAuditeeDocs == 1)
      ) {
        this.customMessage.showErrorMessage(
          'cams.label.auditee.pdca.attachement.validation.suppDoc',
          ''
        );
        return false;
      }
    }

    this.sidebarComponent.showHideLoader(true);
    this.suppDocService.deleteSupportingDocument(this.supportingDocumentValue).subscribe(
      (data: any) => {
        if (data.status == 1) {
          this.customMessage.showSuccessMessage('cams.label.common.operationCompletedSuccessfully');
          this.getSupportingDocList('List');
        }
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }

  downloadSuppDocument(item: { fileName: string; fileType: string; documentId: string }) {
    this.supportingDocumentDto.fileName = item.fileName;
    this.supportingDocumentDto.fileType = item.fileType;
    this.supportingDocumentDto.documentId = item.documentId;

    this.sidebarComponent.showHideLoader(true);

    this.suppDocService.downloadSupportingDoc(this.supportingDocumentDto).subscribe(
      (data: any) => {
        var downloadURL = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = item.fileName;
        link.click();
        this.sidebarComponent.showHideLoader(false);
      },
      error => {
        if (error.error.msgId == undefined || error.error.msgId == '') {
          error.error.msgId = 'cams.label.common.errorOccuredInOperation';
          this.customMessage.showErrorMessage(error.error.msgId, '');
        } else {
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      }
    );
  }

  validateFile(name: String) {
    let ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() == 'xls' || ext.toLowerCase() == 'xlsx') {
      return true;
    } else {
      return false;
    }
  }

  saveSuppDocument() {

    this.uploadStart = true;
    this.fileArray = this.fileDragDrop.selectedFiles;
    if (this.fileArray.length == 0) {
      this.customMessage.showErrorMessage('cams.label.common.mandatoryFileSelectionForUpload', '');
      this.uploadStart = false;
      return false;
    }

    if (this.fileArray.length > 1) {
      this.customMessage.showErrorMessage('cams.label.common.multipleFilesCannotBeDownloaded', '');
      this.uploadStart = false;
      return false;
    }

    this.sidebarComponent.showHideLoader(true);
    const formData = new FormData();
    //let url = environment.SERVER_URL;
    let url = this.urlConfigService.apiServerUrl;
    let fileName;

    for (var i = 0; i < this.fileArray.length; i++) {
      formData.append('files', this.fileArray[i]);
    }
    formData.append('companyId', this.supportingDocumentDto.companyId);
    formData.append('buId', this.supportingDocumentDto.buId);
    formData.append('auditScopeId', this.supportingDocumentDto.auditScopeId);
    formData.append('fileName', this.fileArray[0].name);
    formData.append('auditProgramId', this.supportingDocumentDto.auditProgramId);
    formData.append('departmentId', this.supportingDocumentDto.departmentId);
    formData.append('auditAreaId', this.auditAreaId);
    let fileSize: number = this.fileArray[0].size;
    if (fileSize / (1024 * 1024) > this.maxUploadSizeInMb) {
      this.customMessage.showErrorMessage(
        'cams.label.common.fileSizeCannotBeGreaterThanDefinedMb',
        this.maxUploadSizeInMb + ' MB.'
      );
      this.uploadStart = false;
      return false;
    }

    $.ajax({
      url: url + 'supp-document-upload/upload',
      type: 'POST',
      data: formData,
      dataType: 'text',
      mimeType: 'multipart/form-data;charset=UTF-8',
      processData: false,
      contentType: false,
      cache: false,
      headers: { Authorization: localStorage.getItem(this.TOKEN) },

      error: function (jqXHR, exception) {
        var jsonResponseText = $.parseJSON(jqXHR.responseText);
        $('#showErrorMessage').val(jsonResponseText.msgId);
        $('#showErrorMessage').click();
      },
      complete: function () { },
      success: function (res) {
        this.supportingDocStatus = JSON.parse(res);
        //If duplicate file exists then this.supportingDocStatus.status == 2 and if success then 1 and on error 0
        if (this.supportingDocStatus.status == '2') {
          $('#duplecateFileNotAllowed').click();
        } else {
          $('#showSuccessMessage').click();
        }
        // $("#showSuccessMessage").click();
      },
    });
    //this.sidebarComponent.showHideLoader(false);
  }

  duplecateFileNotAllowed() {
    this.uploadStart = false;
    this.customMessage.showErrorMessage('cams.label.common.duplicateRecordExist', '');
  }

  showSuccessMessage() {
    this.uploadStart = false;

    this.customMessage.showSuccessMessage('cams.label.common.operationCompletedSuccessfully');
    this.getSupportingDocList('List');
    this.fileDragDrop.selectedFiles = [];
    this.fileDragDrop.files = [];

    //this.files.splice(index, 1);
    //this.selectedFiles.splice(index, 1);
    this.fileDragDrop.fileInput.nativeElement.value = null;
    if (this.isDocumentRepositoryCall == true) {
      this.closed();
    }
  }

  showErrorMessage() {
    this.fileDragDrop.deleteAttachment(0);
    this.uploadStart = false;

    if ($('#showErrorMessage').val() == 'cams.label.common.file.extn.not.allowed') {
      this.customMessage.showErrorMessage(
        $('#showErrorMessage').val(),
        this.fileExtnNotAllowedToUpload
      );
    } else {
      this.customMessage.showErrorMessage($('#showErrorMessage').val(), '');
    }
  }

  deleteSupportingDocument(item: SupportingDocumentBean) {

    if (this.userTeamType === 'Auditor Area' ||
      (this.supportingDocumentList.length > 1 ||
        this.pdcaCount == "" ||
        this.pdcaCount == null ||
        this.pdcaCount == 20 ||
        this.pdcaCount == 33 ||
        this.allowAttachementForFifty == false)) {
      this.deleteItem = item;
      let obj = this;
      obj.dialog.confirm(
        obj.ts.transform('cams.label.common.confirm'),
        obj.ts.transform('cams.label.attachmentList.confirmationToDeleteSupportingDocument'),
        async function () {
          obj.deleteSupportingDoc();
          //dialogRef.disableClose = true;
        },
        function () {
          //ACTION: Do this if user says NO
          //that.name = "No clicked";
        }
      );
    } else {
      this.customMessage.showErrorMessage('cam.sup.only.doc.not.delete', '');
    }
  }

  onContentPrinted() {
    if (this.shouldDoIt) {
      this.sidebarComponent.showHideLoader(false);
      this.shouldDoIt = false;
    }
  }
}
